import { render, staticRenderFns } from "./PauseMessageElement.vue?vue&type=template&id=265721b0&scoped=true&"
import script from "./PauseMessageElement.vue?vue&type=script&lang=babel&"
export * from "./PauseMessageElement.vue?vue&type=script&lang=babel&"
import style0 from "./PauseMessageElement.vue?vue&type=style&index=0&id=265721b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265721b0",
  null
  
)

export default component.exports